import { INVALID_PARAMETER } from '../constants/api-error-enums';
import AssuranceData from '../schemas/dictionary/assurance-data';
import constructValidationMessage from './construct-validation-message';

const validateAssuranceData = data => {
  const { error } = AssuranceData.validate(data, {
    abortEarly: false,
    allowUnknown: true
  });

  let reason;
  if (error) {
    reason = INVALID_PARAMETER;
  }

  return constructValidationMessage(error, 'assuranceData', reason);
};

export default validateAssuranceData;
